module.exports = __webpack_public_path__ + "static/media/audio.309dcdd6.svg";